import { useContext } from 'react'
import { createCtx } from '../../../context/_createCtx'
import { RequesterFormContextValues } from '../_props'

export const defaultValues: RequesterFormContextValues = {
    isLoading: false,
    isExternal: false,
    shouldBlockNavigation: false,
    isSaving: false,
    loaderMessage: "Chargement des informations de l'utilisateur...",
    isEditionMode: false,
}

const [ctx, provider] = createCtx(defaultValues)

export const RequesterFormContextProvider = provider

export const useRequesterFormContext = () => useContext(ctx)
